import React, { JSX, useEffect } from 'react';
import Icons from 'components/atoms/Icons';
import { LinkItem } from 'components/types/OSFHeaderTypes';

type PrimarySubNavProps = {
  setActiveSubLinks: (value: React.SetStateAction<number | null>) => void;
  activeSubLinks: number | null;
  index: number;
  link: LinkItem;
};

const PrimarySubNav = (props: PrimarySubNavProps): JSX.Element => {
  const { setActiveSubLinks, activeSubLinks, index, link } = props;
  useEffect(() => {
    window.addEventListener('click', e => {
      if (
        !(e.target as HTMLElement).closest('.utility-dropdown.active') &&
        !(e.target as HTMLElement).closest('.dropdown-container')
      ) {
        setActiveSubLinks(null);
      }
    });
    window.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        setActiveSubLinks(null);
      }
    });
  }, []);

  return (
    <div
      className={
        activeSubLinks === index
          ? 'open dropdown-container'
          : 'dropdown-container'
      }
    >
      <button
        className="utility-link"
        onClick={() =>
          setActiveSubLinks(activeSubLinks === index ? null : index)
        }
        aria-expanded={activeSubLinks === index}
        aria-controls={`utility-dropdown-${index}`}
      >
        {link.fields?.BasePhoneNumber?.value || link.displayName}
        <span className="icon icon-chevron-down">
          <Icons id="chevron-down" />
        </span>
      </button>
      <div
        className={
          activeSubLinks === index
            ? 'active utility-dropdown'
            : 'utility-dropdown'
        }
        id={`utility-dropdown-${index}`}
      >
        {link.fields.UtilitySubLink.map(sublink => {
          return (
            <a
              key={sublink.id}
              href={sublink.fields?.generalLink?.value?.href}
              target={sublink.fields?.generalLink?.value?.target}
              className="utility-link"
              tabIndex={activeSubLinks === index ? 0 : -1}
            >
              {sublink.fields?.generalLink?.value?.text || sublink.displayName}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default PrimarySubNav;
